import Navigation from "./Navigation";
import ConnectionSpinner from "./ConnectionSpinner";
import ApplicationConfig from "./ApplicationConfig";
import ApplicationContinue from "./ApplicationContinue";
import { getDecryptParam, getPathname } from "logic/typeDecryptParams";
import { setApplicationParams } from "logic/actions/application";
import { useDispatch } from "react-redux";
import NewTemplate from "./NewTemplate"
// import ExpireSession from "./ExpireSession";
import { useSelector } from "react-redux";
import SlowNetworkWarning from "./SlowNetworkWarning";
import { useEffect } from "react";

export default function App() {
  const isInProgress = useSelector((store) => store.apiFetch.isInProgress);
  // const statusExpire = useSelector((store) => store.expireTimeOut.stsExpireTime)
  // console.log(process.env.NODE_ENV, process.env.REACT_APP_SHOW_BUILD_VERISON, process.env.REACT_APP_SHOW_ONBOARDING_RESULT)
  const dispatch = useDispatch();
  // const pathname = getPathname();
  const { template } = getDecryptParam()

  // new template for DDP
  const showNewTemplate = template === '2';
  let isParams = {
    showNewTemplate
  }
  useEffect(() => {
    setApplicationParams(isParams)(dispatch)
  }, [])

  return (
    <ConnectionSpinner>
      {isInProgress && <SlowNetworkWarning />}
      {/* {statusExpire && <ExpireSession />} */}
      {showNewTemplate ? (
        <NewTemplate />
      ) : (
        <ApplicationConfig>
          <ApplicationContinue>
            <Navigation />
          </ApplicationContinue>
        </ApplicationConfig>
      )}
    </ConnectionSpinner>
  );
}
